// React Basic and Bootstrap
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'reactstrap';

// import images
import brandon from '../../images/team/brandon_bruce.jpeg'
import john from '../../images/team/john_bruck.jpeg'
import Colors from "../../Colors";

class TheTeam extends Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    return (
      <React.Fragment>
        <section className='section bg-light' style={{paddingLeft: 30, paddingRight: 30}}>
          <Row className="justify-content-center">
            <Col className="text-center">
              <div className="section-title mb-4 pb-2">
                <h4 className="display-3 mb-4" style={{color: Colors.darkBlue()}}>Startup Knox Team</h4>
              </div>
            </Col>
          </Row>
          <Row>
          <Col md={6} className="col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div className="section-title ml-lg-4">
              <Row>
                <Col md={3} style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                  <img src={brandon} style={{maxHeight: 150, maxWidth: 150}} className="img-fluid shadow rounded" alt="" />
                  <h4 className="title mb-4" style={{fontSize: 24, textAlign: 'center'}}><span className="text-primary">Brandon Bruce</span></h4>
                </Col>
                <Col md={8}>
                  <p className="text-muted">
                    Brandon is chair of the <a href="http://knoxec.com/" target={"_blank"} style={{color: Colors.persimmon()}}>Knoxville Entrepreneur Center</a>,
                    co-founder of the <a href="http://www.knoxtech.org" target={"_blank"} style={{color: Colors.persimmon()}}>Knoxville Technology Council</a>,
                    chair of <a href="https://jaeasttennessee.org/" target={"_blank"} style={{color: Colors.persimmon()}}>Junior Achievement</a>,
                    chair of <a href="https://www.themuseknoxville.org/" target={"_blank"} style={{color: Colors.persimmon()}}>The Muse Knoxville</a>,
                    member of the <a href="https://innov865.com/" target={"_blank"} style={{color: Colors.persimmon()}}>Innov865 Alliance</a>,
                    and board member at <a href="https://www.tnresearchpark.org/" target={"_blank"} style={{color: Colors.persimmon()}}>UT Research Park at Cherokee Farm</a>,
                    the American Museum of Science and Energy, and Leadership Knoxville. He is co-founder of <a href="https://www.uncat.com/" target={"_blank"} style={{color: Colors.persimmon()}}>Uncat</a> and was previously co-founder
                    and COO of <a href="https://www.cirrusinsight.com/" target={"_blank"} style={{color: Colors.persimmon()}}>Cirrus Insight</a> which was #41 on the Inc. 500 in 2016. Brandon set a Guinness World Record with Knox County Schools
                    and Knox Education Foundation for the largest student coding lesson. Brandon interviews entrepreneurs on the <a href="https://www.startupknox.com/podcast" target={"_blank"} style={{color: Colors.persimmon()}}>Startup Knox Podcast.</a>
                  </p>
                  <a href="https://www.linkedin.com/in/brandonbruce/" target={"_blank"} className="btn btn-outline-primary mt-3">LinkedIn</a>
                </Col>
              </Row>
            </div>
          </Col>
          <Col md={6} className="col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div className="section-title ml-lg-4">
              <Row>
                <Col md={3} style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                  <img src={john} style={{maxHeight: 150, maxWidth: 150, alignSelf: 'center'}} className="img-fluid shadow rounded" alt="" />
                  <h4 className="title mb-4" style={{fontSize: 24, textAlign: 'center'}}><span className="text-primary">John Bruck</span></h4>
                </Col>
                <Col md={8}>
                  <p className="text-muted">
                    John is a Senior Advisor to the <a href="https://innovationcrossroads.ornl.gov/program" target={"_blank"} style={{color: Colors.persimmon()}}>Oak Ridge National Laboratory’s Innovation Crossroads </a>
                    program and the <a href="https://www.tnresearchpark.org/spark/" target={"_blank"} style={{color: Colors.persimmon()}}>University of Tennessee Research Park’s Spark Innovation Center. </a>He is a mentor and EIR in the <a href="https://tnadvancedenergy.com/energy-mentor-network/mentors/" target={"_blank"} style={{color: Colors.persimmon()}}>Tennessee Energy Mentor Network </a>
                    and an angel investor with <a href="https://www.qca.com/" target={"_blank"} style={{color: Colors.persimmon()}}>Queen City Angels </a>in Cincinnati.
                    John is also an advisor and board member for several early-stage companies including <a href="https://nthcycle.com/" target={"_blank"} style={{color: Colors.persimmon()}}>Nth Cycle</a> and <a href="https://therealgoodkitchen.com/" target={"_blank"} style={{color: Colors.persimmon()}}>Real Good Kitchen. </a>
                    From 1988 to 2013, John was the Founder, Chairman, and President of BHE Environmental which was #98 on the Inc. 500 list in 1993,
                    and its real estate affiliate, BHE Properties.
                  </p>
                  <a href="https://www.linkedin.com/in/johnbruck/" target={"_blank"} className="btn btn-outline-primary mt-3">LinkedIn</a>
                </Col>
              </Row>
            </div>
          </Col>
          </Row>
        </section>
      </React.Fragment>
    )
  }
}

export default TheTeam;
